// extracted by mini-css-extract-plugin
export default {"dock":"Dock_dock__l5+sD","item":"Dock_item__BYD4K","active":"Dock_active__jh1d3","tip":"Dock_tip__G9HLb"};